import { RouteConfig } from 'vue-router';

import ClubDetails from '@/views/club/Details.vue';

export const clubDetailsRoute: RouteConfig = {
  path: '',
  name: 'club',
  component: ClubDetails,
  meta: {
    authorized: true
  }
};
